<section class="filters global-filters-container">
    <lib-search-input
        [(text)]="filters.searchText"
        [placeholderText]="'Name or Address'"
        name="search"
        (textChange)="onFilterChanged()"
    >
    </lib-search-input>
    <app-additional-filters class="filter" [config]="additionalFiltersConfig"></app-additional-filters>
    <app-clear-filters-button></app-clear-filters-button>
</section>

<ng-template #userTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="
            $safeNavigationMigration(data.object?.firstName) + ' ' + $safeNavigationMigration(data.object?.lastName)
        "
        [subtitle]="data.object?.email ?? ''"
        [titlePrefix]="!data.object?.isActive ? { text: 'Inactive', textColor: 'danger' } : undefined"
    >
    </app-custom-menu-item>
</ng-template>
